import SuccessStep from './SuccessStep';
import './SuccessStep.scss';

export default SuccessStep;
